import React from 'react';
import { Text } from '@beef/ui-kit';
import { Picture } from '@fttb/common/components';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var ContentHeader = function ContentHeader(_ref) {
  var description = _ref.description,
    img = _ref.img,
    subTitle = _ref.subTitle,
    title = _ref.title;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('container'),
    "data-t-id": "common-ContentHeader"
  }, img && /*#__PURE__*/React.createElement(Picture, {
    alt: "",
    src: img
  }), title && /*#__PURE__*/React.createElement(Text, {
    size: "size2-m",
    tagType: "h2"
  }, title), subTitle && /*#__PURE__*/React.createElement(Text, {
    size: "size4-m",
    tagType: "h3"
  }, subTitle), description && /*#__PURE__*/React.createElement(Text, {
    size: "size5-r-s",
    tagType: "h3"
  }, description));
};